<template>
  <div id="access-logs-dialog" class="custom-modal">
    <div class="modal-body">
      <el-table v-loading="$store.state.accesslogs.loading" ref="multipleTable" :data="$store.state.accesslogs.items" style="width: 100%">
        <el-table-column property="title" :label="$t('event.table.participant')" min-width="150">
          <template slot-scope="scope">
            <ParticipantMini :data="$store.state.accesslogs.participants.find((k) => k.id == scope.row.participantID)" />
          </template>
        </el-table-column>

        <el-table-column property="title" :label="$t('event.table.controller')" min-width="150">
          <template slot-scope="scope">
            <div>
              <span v-if="$store.state.accesslogs.users.some((k) => k.id == scope.row.userID)">{{ $store.state.accesslogs.users.find((k) => k.id == scope.row.userID).firstName }} {{ $store.state.accesslogs.users.find((k) => k.id == scope.row.userID).lastName }}</span>
              <span v-else>{{ $t("system") }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column property="title" :label="$t('event.table.controlType')" min-width="150">
          <template slot-scope="scope">
            <span>{{ $enums.accessLogType.find((k) => k.value == scope.row.logType).title }}</span>
          </template>
        </el-table-column>

        <el-table-column property="title" :label="$t('event.table.place')" min-width="150">
          <template slot-scope="scope">
            <div>
              <span>{{ $store.state.venues.items.find((k) => k.id == scope.row.venueID).title }}</span>
              <span v-if="scope.row.liveStreamID != null && $store.state.accesslogs.liveStreams.some((k) => k.id == scope.row.liveStreamID)">{{ $t("event.components.liveEventExp.title") }}: {{ $store.state.accesslogs.liveStreams.find((k) => k.id == scope.row.liveStreamID).title }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column property="title" :label="$t('event.table.status')" min-width="150">
          <template slot-scope="scope">
            <div>
              <span :style="'color:' + (scope.row.status == 1 ? 'green' : 'red')">{{ $enums.accessLogStatus.find((k) => k.value == scope.row.status).title }}</span>
              <span v-if="scope.row.status == 2">{{ scope.row.systemMessageKey }}</span>
              <span>{{ $moment(scope.row.createDate).format("LLL") }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('event.table.processes')" width="110" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
              <el-popconfirm @confirm="deleteItem(scope.$index)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                <el-button slot="reference" type="danger" icon="fas fa-trash" circle size="mini"></el-button>
              </el-popconfirm>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="$store.state.accesslogs.filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper" :total="$store.state.accesslogs.filter.total"></el-pagination>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("onsiteUtilities.controlPoints.accessLogs.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="exportExcel">{{ $t("onsiteUtilities.controlPoints.accessLogs.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import VenueAddUpdate from "../../components/VenueAddUpdate";
import ParticipantMini from "../../components/ParticipantMini";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Access logs",
  },
  components: { VenueAddUpdate, PageCountInfo, ParticipantMini },
  name: "AccessLogs",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "tags",
    };
  },
  methods: {
    exportExcel() {
      this.$confirm(this.$t("message.export"), this.$t("message.warn"), {
        confirmButtonText: this.$t("event.variables.yes"),
        cancelButtonText: this.$t("event.variables.no"),
        type: "warning",
      }).then(() => {
        axios.post("accesslog/export", { id: this.$store.state.accesslogs.filter.venueID }).then((res) => {
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
          }
        });
      });
    },
    itemUpdated(item) {
      var index = this.$store.state.accesslogs.items.findIndex((k) => k.id == item.id);
      if (index != -1) {
        this.$store.state.accesslogs.items.splice(index, 1, item);
      }
    },
    itemAdded(item) {
      this.$store.dispatch("getAccessLogs");
    },
    handleSizeChange(take) {
      this.$store.commit("setAccessLogTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setAccessLogPage", page);
    },
    deleteItem(index) {
      this.$store.dispatch("deleteAccessLog", { index, context: this });
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleAccessLog", { index, value });
    },
    handleSelectionChange(items) {
      this.$store.commit("setSelectedAccessLogs", items);
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
  },
  mounted() {
    this.$store.dispatch("getAccessLogs");
  },
  created() {},
  computed: {
    skip() {
      return (this.$store.state.accesslogs.filter.page - 1) * this.$store.state.accesslogs.filter.take;
    },
    take() {
      return this.skip + this.$store.state.accesslogs.items.length;
    },
  },
  watch: {
    "$store.state.accesslogs.filter.searchTerm": function() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getAccessLogs");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/event/AccessLogs.vue